import * as yup from 'yup'

export const selectSchema = yup
  .object()
  .shape({
    // id: yup.number().required(),
    // kodZdroj: yup.string().required(),
    // nazov: yup.string().required()
  })
  .nullable()

export const selectRequiredSchema = selectSchema.required()

export const stringRequiredSchema = yup.string().required()

export const ibanSchema = yup
  .string()
  .length(24)
  .matches(/^SK\d{22}$/, 'Nesprávny formát IBAN')
  .required()

export const rodneCisloSchema = yup
  .string()
  .min(9)
  .max(10)
  .matches(/^[0-9]+$/, "Pole môže obsahovať len číslice")

export const zaradeniaSchema = yup
  .array()
  .of(yup.string())
  .min(1, 'Vyberte aspoň jednu možnosť')
  .required()

export const titulySchema = yup.array().of(yup.object().shape({})).ensure()

export const telefonneCisloSchema = yup
  .string()
  .max(17)
  .matches(
    /^\+[0-9][0-9 ().-]{5,}[0-9]$/,
    'Nesprávne telefónne číslo (zadajte predčíslie štátu. Napr. Slovensko +421…)'
  )
export const telefonneCisloRequiredSchema = telefonneCisloSchema.required()
export const emailSchema = yup.string().email()
export const emailRequiredSchema = emailSchema.required()

export const stringNumberSchema = yup.string().matches(/^[0-9]+$/, 'Hodnota musí obsahovať iba čísla')

export const supisneCisloSchema = stringNumberSchema.required()

export const orientacneCisloSchema = yup.string().matches(/^[a-zA-Z/0-9]+$/, 'Orientačné číslo môže obsahovať iba čísla, písmená alebo lomku').transform((v) => {
  if(v) {
    return v.replace('', null)
  }})

export const kontaktSchema = yup.object().shape({
  email: emailRequiredSchema,
  telefonneCislo: telefonneCisloRequiredSchema,
  webstranka: yup.string(),
})

export const kontaktNoWebSchema = yup.object().shape({
  email: emailRequiredSchema,
  telefonneCislo: telefonneCisloRequiredSchema,
})

export const adresaSchema = yup.object().shape({
  isSkSelected: yup.boolean(),
  hasObecList: yup.boolean(),
  stat: selectSchema.required(),
  kraj: selectSchema.when('isSkSelected', {
    is: true,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.optional(),
  }),
  okres: selectSchema.when('isSkSelected', {
    is: true,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.optional(),
  }),
  obec: selectSchema.when('isSkSelected', {
    is: true,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.optional(),
  }),
  obecZahranicie: yup.string().when('isSkSelected', {
    is: false,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.optional(),
  }),
  psc: stringNumberSchema.when('isSkSelected', {
    is: true,
    then: (schema) => schema.length(5).required(),
    otherwise: () => yup.string().min(0).max(10).required().typeError('Zahraničné psč môže mať max 10 znakov'),
  }).nullable(),
  supisneCislo: supisneCisloSchema.required(),
  orientacneCislo: orientacneCisloSchema.nullable(),
  dalsieInformacie: yup.string().nullable(),
  okresZahranicie: yup.string().nullable(),
  krajZahranicie: yup.string().nullable(),
})
